import React, { HTMLAttributes, PropsWithChildren, RefObject } from 'react';
import clsx from 'clsx';

import { Slot, type AsChildProps } from '@/stories/atoms/Slot/Slot';
import styles from './card.module.css';

export type ThemeType = 'brand' | 'grey-light' | 'grey-dark' | 'ideeri' | 'ideeri-contrast'

export type BaseCardProps = PropsWithChildren & {
  /** background variant */
  background?: ThemeType,
  /** The card has a border */
  border?: boolean,
  /** Apply shodow */
  shadow?: boolean,
  /** The card size in nb of cols */
  size?: number,
  /** The padding size */
  padding?: 'xs' | 's' | 'm' | 'l' | 'xl' | '0',
  className?: string,
  ref?: RefObject<null>
}

export type CardProps = AsChildProps<
  BaseCardProps,
  HTMLAttributes<HTMLDivElement>
>

export const Card = ({background, border, shadow, asChild, padding, className, size, children, ...props}: CardProps)=> {
  const Component = asChild ? Slot : "div";

  return (
    <Component className={clsx(styles.wrapper, background && styles[background], border && styles.border, shadow && styles.shadow, className)} style={{
        '--nb-cols': size,
        ...(padding ? {'--padding-size': `var(--spacing-${padding})`} : {})
      } as React.CSSProperties}
      {...props}>
      {children}
    </Component>
  )
};
